import React from 'react';

import { Flex } from '@qality/common-components/src/atoms/Flex';
import { Text } from '@qality/common-components/src/atoms/Text';

export function EmptyRepository(): JSX.Element {
  return (
    <Flex justifyCenter paddingSize='medium'>
      <Text>No Test Cases were found.</Text>
    </Flex>
  );
}
